import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/_services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-business-list',
  templateUrl: './business-list.component.html',
  styleUrls: ['./business-list.component.scss']
})
export class BusinessListComponent implements OnInit {
  businessDetails: any;
  responseData: any;
  bankDetails: any;
  cnssCnamgsForm: FormGroup;
  isSubmitted: boolean = false;
  response: any;

  constructor(private snackBar: MatSnackBar, private ngxUiLoaderService: NgxUiLoaderService, private api: ApiService, private formBuilder: FormBuilder) { }

  ngOnInit() {

    this.cnssCnamgsForm = this.formBuilder.group({
      is_cnamgs: [false, Validators.required],
      is_cnss: [false, Validators.required],
    });

    this.getBusinessDetails()
  }


  getBusinessDetails() {
    this.ngxUiLoaderService.start();
    this.api.getBusinessList().pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();

        this.responseData = data;
        if (this.responseData.status == 200) {
          this.businessDetails = this.responseData.results;
          this.cnssCnamgsForm.controls['is_cnamgs'].setValue(this.businessDetails.is_cnamgs);
          this.cnssCnamgsForm.controls['is_cnss'].setValue(this.businessDetails.is_cnss);
          // this.bankDetails = this.responseData.banks
          // console.log('ingott  vaayyo..!',this.bankDetails);

          // console.log('Erangi vaaadaa thorappaaaa......',this.businessDetails);
        } else {
          this.snackBar.open(this.responseData.message, "OK", {
            duration: 5000,
          });
        }

      },
        error => {
        });
  }

  onSubmitCnssCnamgs() {
    console.log(this.cnssCnamgsForm.value);
    this.isSubmitted = true;
    if (this.cnssCnamgsForm.invalid) {
      return;
    }
    this.ngxUiLoaderService.start();
    let data = {
      is_cnamgs: this.cnssCnamgsForm.value.is_cnamgs,
      is_cnss: this.cnssCnamgsForm.value.is_cnss,
      uuid: this.businessDetails.uuid,
    };

    this.api.cnssCnamgsStatusUpdate(data).pipe(first())
      .subscribe(data => {
        this.isSubmitted = false;
        this.ngxUiLoaderService.stop();
        this.response = data;
        if (this.response.status == 200) {
          this.getBusinessDetails();
          this.snackBar.open(this.response.message, "OK", {
            duration: 2000,
          });
        } else {
          this.snackBar.open(this.response.message, "OK", {
            duration: 2000,
          });
        }
      },
        error => {
          this.isSubmitted = false;
          this.ngxUiLoaderService.stop();
        });
  }



}
